import React, { useState } from 'react';

const OutputReportSearchFilters = ({ onSearch, loading }) => {
    const [filters, setFilters] = useState({
        RecipientPartyId: '',
        CaseId: '',
        PatientName: '',
        ClientName: '',
        Downloaded: '',
        DateFrom: '',
        DateTo: '',
        IncludeDeleted: false,
        IncludeExpired: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const criteria = { ...filters };

        if (criteria.RecipientPartyId) {
            criteria.RecipientPartyId = parseInt(criteria.RecipientPartyId, 10);
        } else {
            delete criteria.RecipientPartyId;
        }

        if (criteria.Downloaded === '') {
            delete criteria.Downloaded;
        } else {
            criteria.Downloaded = criteria.Downloaded === 'true';
        }

        if (!criteria.CaseId) delete criteria.CaseId;
        if (!criteria.PatientName) delete criteria.PatientName;
        if (!criteria.ClientName) delete criteria.ClientName;
        if (!criteria.DateFrom) delete criteria.DateFrom;
        if (!criteria.DateTo) delete criteria.DateTo;

        onSearch(criteria);
    };

    return (
        <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', alignItems: 'end' }}>
                <div>
                    <label>Recipient Party ID</label>
                    <input type="number" name="RecipientPartyId" value={filters.RecipientPartyId}
                        onChange={handleChange} className="form-control" />
                </div>
                <div>
                    <label>Case ID</label>
                    <input type="text" name="CaseId" value={filters.CaseId}
                        onChange={handleChange} className="form-control" />
                </div>
                <div>
                    <label>Patient Name</label>
                    <input type="text" name="PatientName" value={filters.PatientName}
                        onChange={handleChange} className="form-control" />
                </div>
                <div>
                    <label>Client Name</label>
                    <input type="text" name="ClientName" value={filters.ClientName}
                        onChange={handleChange} className="form-control" />
                </div>
                <div>
                    <label>Status</label>
                    <select name="Downloaded" value={filters.Downloaded}
                        onChange={handleChange} className="form-control">
                        <option value="">All</option>
                        <option value="true">Downloaded</option>
                        <option value="false">Not Downloaded</option>
                    </select>
                </div>
                <div>
                    <label>Date From</label>
                    <input type="date" name="DateFrom" value={filters.DateFrom}
                        onChange={handleChange} className="form-control" />
                </div>
                <div>
                    <label>Date To</label>
                    <input type="date" name="DateTo" value={filters.DateTo}
                        onChange={handleChange} className="form-control" />
                </div>
                <div>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? 'Searching...' : 'Search'}
                    </button>
                </div>
            </div>
            <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                <label>
                    <input type="checkbox" name="IncludeDeleted" checked={filters.IncludeDeleted}
                        onChange={handleChange} />
                    {' '}Include Deleted
                </label>
                <label>
                    <input type="checkbox" name="IncludeExpired" checked={filters.IncludeExpired}
                        onChange={handleChange} />
                    {' '}Include Expired
                </label>
            </div>
        </form>
    );
};

export default OutputReportSearchFilters;
